// filepath: apps/web/src/features/promote/PromotionReviewGateRoute.tsx
//
// FR-UI-PROM-2: route shell for the non-skippable human-review gate.
//
// URL: /promote/review?reviewId=<uuid>
//
// Mirrors PromotionDiffRoute (FR-UI-PROM-1). The reviewer navigates
// here from the staging promotion-review list. The gate page itself
// is the FR-UI-PROM-2 deliverable; this route is the thin shell that
// extracts the reviewId from the URL and mounts the page.
//
// URL scope: the ONLY query-param this route reads is `reviewId`.
// No `?skip`, `?auto_approve`, `?bypass_review` — those would be
// skipped (see the FR-UI-PROM-2 AC-4 contract on
// PromotionReviewGatePage.tsx).

import React from "react";
import { PromotionReviewGatePage } from "./PromotionReviewGatePage";

interface PromotionReviewGateRouteProps {
  reviewId: string;
}

/**
 * PromotionReviewGateRoute — route-level shell for the gate page.
 *
 * URL: /promote/review?reviewId=<uuid>
 *
 * Note: environmentKind gating (FR-UI-PROM-1 AC-3 / FR-UI-PROM-2
 * staging-only surface) is enforced server-side. The SPA only
 * renders this route when the reviewer navigates from the STAGING
 * promotion review list.
 */
export function PromotionReviewGateRoute({
  reviewId,
}: PromotionReviewGateRouteProps): React.ReactElement {
  if (!reviewId) {
    return (
      <div className="p-6">
        <p className="text-muted-foreground text-sm">
          No reviewId specified. Navigate from the promotion review list.
        </p>
      </div>
    );
  }
  return <PromotionReviewGatePage reviewId={reviewId} />;
}
